import { AnimatePresence, motion } from 'framer-motion';

export default function ClearMemoryDialog({
  show,
  onClose,
  onConfirm,
  isDarkMode,
}) {
  const bgColor = isDarkMode ? 'bg-gray-800' : 'bg-white';
  const textColor = isDarkMode ? 'text-white' : 'text-gray-900';
  const subTextColor = isDarkMode ? 'text-gray-300' : 'text-gray-600';
  const cancelBg = isDarkMode
    ? 'bg-gray-900 hover:bg-gray-700 text-gray-200 border-gray-600'
    : 'bg-white hover:bg-gray-100 text-gray-700 border-gray-300';

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="clear-memory-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            className={`rounded-2xl shadow-2xl w-full max-w-sm sm:p-8 p-5 ${bgColor}`}
          >
            <h2
              className={`text-lg sm:text-xl font-bold mb-3 tracking-tight text-center ${textColor}`}
            >
              Confirm Memory Clear
            </h2>
            <p className={`text-sm mb-6 text-center ${subTextColor}`}>
              This will erase your conversation history. Legal knowledge will be
              preserved.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={onClose}
                className={`w-full py-2 px-4 rounded-lg border font-medium transition-colors ${cancelBg}`}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  onConfirm();
                  onClose();
                }}
                className="w-full py-2 px-4 rounded-lg bg-gradient-to-r from-brand to-brandDark text-white font-semibold shadow-sm transition-all"
              >
                Clear Memory
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
